import { useCallback } from 'react';
import { useBi } from '@wix/form-fields';
import { submitForm as submitFormBi } from '@wix/bi-logger-forms-data/v2';
export var BiFormSubmissionStatus;
(function (BiFormSubmissionStatus) {
    BiFormSubmissionStatus["INIT"] = "INITIATE_SUBMISSION";
    BiFormSubmissionStatus["VALIDATION_FAILURE"] = "VALIDATION_FAILURE";
    BiFormSubmissionStatus["FAILURE"] = "FAILURE";
    BiFormSubmissionStatus["SUCCESS"] = "SUCCESS";
})(BiFormSubmissionStatus || (BiFormSubmissionStatus = {}));
export const useSubmit = ({ validateAndScrollToError, submitAction, onSubmit, onSubmitSuccess, onSubmitFailure, resetFormValues, }) => {
    const { report } = useBi();
    const reportSubmitFormBi = useCallback((status) => report(submitFormBi({ submission_status: status })), [report]);
    const submitForm = useCallback(async () => {
        const errors = await validateAndScrollToError();
        onSubmit?.();
        reportSubmitFormBi(BiFormSubmissionStatus.INIT);
        if (errors?.length) {
            reportSubmitFormBi(BiFormSubmissionStatus.VALIDATION_FAILURE);
            return;
        }
        let response;
        try {
            response = await submitAction();
        }
        catch (error) {
            onSubmitFailure?.(error);
            reportSubmitFormBi(BiFormSubmissionStatus.FAILURE);
            throw new Error('Form submission failed');
        }
        if (response) {
            onSubmitSuccess?.();
            reportSubmitFormBi(BiFormSubmissionStatus.SUCCESS);
            resetFormValues?.();
        }
        return response;
    }, [
        validateAndScrollToError,
        submitAction,
        onSubmit,
        onSubmitFailure,
        onSubmitSuccess,
        resetFormValues,
        reportSubmitFormBi,
    ]);
    return { submitForm };
};
//# sourceMappingURL=use-submit.js.map